;(function () {
  var chartElement = document.getElementById("chartist--desktop-vs-mobile");

  if (!chartElement || typeof Chartist === "undefined" || !Chartist.Line) return;

  var labels = ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"];

  var chart = new Chartist.Line(
    "#chartist--desktop-vs-mobile",
    {
      labels: labels,
      series: [
        {
          name: "series-desktop",
          data: [1100, 1225, 1325, 1410, 1475, 1525, 1600, 1715, 1750]
        },
        {
          name: "series-mobile",
          data: [400, 600, 700, 950, 1100, 1300, 1500, 1780, 1900]
        }
      ]
    },
    {
      fullWidth: true,
      height: "100%",
      showPoint: true,
      lineSmooth: true,
      chartPadding: {
        top: 20,
        right: 40,
        bottom: 4,
        left: 0
      },
      series: {
        "series-desktop": {
          showArea: true
        },
        "series-mobile": {
          showArea: true
        }
      },
      axisY: {
        offset: 48,
        labelInterpolationFnc: function (value) {
          return value + "m";
        }
      },
      axisX: {
        showGrid: false
      }
    }
  );

  if (typeof CustomEvent === "function") {
    document.dispatchEvent(new CustomEvent("addResizeCharts", { detail: { newResizeCharts: [chart] } }));
  }
})();
